module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.show) ? _c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.options), function(option) {
    return _c('ripple-button', {
      staticClass: "button",
      attrs: {
        "text": option.name,
        "id": option.id
      },
      on: {
        "button-click": _vm.answer
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31408df9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiOptions.vue
// module id = 141
// module chunks = 1